import axios from "axios";

const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolve the effective backend URL.
 * If the env var points to a different origin than the page currently
 * loaded (typical case after linking a custom domain: env still has the
 * old emergent.host URL while the page is served from the custom domain),
 * fall back to same-origin. Emergent's ingress routes /api/* to the
 * backend regardless of the host header, so same-origin always works.
 */
function resolveBackend() {
  if (typeof window === "undefined") return ENV_BACKEND_URL;
  try {
    const envOrigin = new URL(ENV_BACKEND_URL).origin;
    if (envOrigin === window.location.origin) return ENV_BACKEND_URL;
    // Cross-origin would trigger CORS — prefer same-origin which avoids CORS entirely
    return window.location.origin;
  } catch {
    return window.location.origin;
  }
}

const BACKEND_URL = resolveBackend();

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Attach bearer if available (fallback when cookies blocked across origins)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("entracte_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const BACKEND = BACKEND_URL;
